import store from '@v/Modules/Staff/Core/Site/store';

if (document.querySelector('#staff-listing')) {
    window['staff_listing_vue_instance'] = new Vue({
        store,
        el: '#staff-listing'
    })
}